import React, { Component } from 'react'
import PropTypes            from 'prop-types'
import './index.less'

class Toast extends Component {

  timer = null

  componentDidMount() {
    this.delay()
  }

  componentDidUpdate() {
    if (this.props.show) {
      this.delay()
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
  }

  delay() {
    const { timeout } = this.props
    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.props.onHide()
    }, timeout)
  }

  render() {
    const { icon, show } = this.props
    return (
      <div className="toast" style={{ display: show ? 'block' : 'none' }}>
        <div className={`icon-${icon}`}></div>
        <div className="toast-body">
          {this.props.children}
        </div>
      </div>
    )
  }
}

Toast.propTypes = {
  show: PropTypes.bool,
  icon: PropTypes.oneOf(['success', 'deleted']),
  timeout: PropTypes.number,
  onHide: PropTypes.func,
}

Toast.defaultProps = {
  show: false,
  icon: 'success',
  timeout: 2000,
  onHide: () => {
  },
}

export default Toast


// WEBPACK FOOTER //
// ./src/components/Toast/index.js